export default __webpack_public_path__ + "static/media/form-anchor-active.1cce3c0b.svg";